// A deployment can change the asset manifest, so a document loaded before it
// still references the previous build and has to be replaced.
//
// Replacing it the moment the new deployment is noticed would discard whatever
// the user is in the middle of, which is the same harm the deployment reload
// was already causing. So the document is only marked here. The routing layer
// loads the replacement at the next navigation, where the current view is torn
// down regardless and the load costs the user nothing extra.
//
// The mark is module state, which is per document by construction: it describes
// this tab, and a loaded replacement starts without it.
let pending = false;

export function markDeploymentPending(): void {
  pending = true;
}

export function isDeploymentPending(): boolean {
  return pending;
}
